import React from 'react'
import { IconCheckCircleFilled } from 'suomifi-icons'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { HeadingWithIcon } from 'todistukset-ui/src/vtj/components/order-wizard/OrderCompleteHeading.sc'
import { useTodistusTheme } from 'todistukset-ui/src/vtj/components/theme/useTodistusTheme'

const OrderCompleteHeading = ({
  titleId,
  headingTranslationKey,
}: {
  titleId: string
  headingTranslationKey: string
}): React.JSX.Element => {
  const {
    colors: { successDark1 },
  } = useTodistusTheme()

  return (
    <HeadingWithIcon variant="h2" id={titleId}>
      <IconCheckCircleFilled color={successDark1} />
      <LocalizedString stringKey={headingTranslationKey} />
    </HeadingWithIcon>
  )
}

export default OrderCompleteHeading
